import { arrayOf, func, object } from 'prop-types';
import React from 'react';
import { IoIosFunnel } from 'react-icons/io';
import {
  Button,
  Col,
  CustomInput,
  Form,
  FormGroup,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

import createModalToggle from '../create-modal-toggle';

function TableFiltersModal({
  toggle,
  allColumns,
  currentColumns,
  onHandleChange,
  onHandleReset,
  onHandleSave,
}) {
  const checkboxes = [...allColumns].map(column => {
    const label = column.Label ? column.Label : column.Header;
    const isChecked = currentColumns
      .map(item => item.Label || item.Header)
      .includes(label);
    return (
      <FormGroup key={label} check>
        <CustomInput
          type="switch"
          label={label}
          id={label}
          onChange={onHandleChange}
          checked={isChecked}
        />
      </FormGroup>
    );
  });
  const middleIndex = Math.ceil(checkboxes.length / 2);
  return (
    <>
      <ModalHeader toggle={toggle}>Available Filters</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col className="filter-modal-col">
              {checkboxes.slice(0, middleIndex)}
            </Col>
            <Col className="filter-modal-col">
              {checkboxes.slice(middleIndex)}
            </Col>
          </Row>
        </Form>
        <ModalFooter>
          <Button onClick={onHandleReset}>Reset</Button>
          <Button
            color="primary"
            onClick={() => {
              onHandleSave();
              toggle();
            }}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalBody>
    </>
  );
}

TableFiltersModal.propTypes = {
  toggle: func.isRequired,
  currentColumns: arrayOf(object.isRequired).isRequired,
  allColumns: arrayOf(object.isRequired).isRequired,
  onHandleChange: func.isRequired,
  onHandleReset: func.isRequired,
  onHandleSave: func.isRequired,
};

export default createModalToggle(
  <span>
    <IoIosFunnel size="20px" />
  </span>,
  TableFiltersModal,
  { className: 'filters-modal-button', color: 'none' },
  { size: 'lg' },
);
